import { TributeDef } from '@mythos/game/GameModel';

import SketchAllIn from '../assets/card_images/TributeSketchAllIn.jpg';
import SketchBringPeace from '../assets/card_images/TributeSketchBringPeace.jpg';
import SketchGrowBounty from '../assets/card_images/TributeSketchGrowBounty.jpg';
import SketchGrowCommunity from '../assets/card_images/TributeSketchGrowCommunity.jpg';
import SketchGrowConquest from '../assets/card_images/TributeSketchGrowConquest.jpg';
import SketchGrowFaith from '../assets/card_images/TributeSketchGrowFaith.jpg';
import SketchGrowLegend from '../assets/card_images/TributeSketchGrowLegend.jpg';
import SketchGrowPolis from '../assets/card_images/TributeSketchGrowPolis.jpg';
import SketchImpulsiveChoice from '../assets/card_images/TributeSketchImpulsiveChoice.jpg';
import SketchOverpower from '../assets/card_images/TributeSketchOverpower.jpg';
import SketchPatientChoice from '../assets/card_images/TributeSketchPatientChoice.jpg';
import SketchPersevere from '../assets/card_images/TributeSketchPersevere.jpg';
import SketchPunishWeakness from '../assets/card_images/TributeSketchPunishWeakness.jpg';
import SketchSeekHumility from '../assets/card_images/TributeSketchSeekHumility.jpg';
import SketchSeekModesty from '../assets/card_images/TributeSketchSeekModesty.jpg';
import SketchSeekWonder from '../assets/card_images/TributeSketchSeekWonder.jpg';
import SketchShowMight from '../assets/card_images/TributeSketchShowMight.jpg';
import SketchShowPiety from '../assets/card_images/TributeSketchShowPiety.jpg';

function tribute(
  name: string,
  subtitle: string,
  image: string,
  func: string,
  params: string = '',
): TributeDef {
  return {
    module: 'core',
    defID: `tribute2_${name.replace(/\s/g, '_').toLowerCase()}`,
    name,
    subtitle,
    imageName: image,
    tokens: 1,
    function: func,
    params,
  };
}

export const ALL_TRIBUTE2_DEFS: TributeDef[] = [
  tribute(
    'Grow Bounty',
    'Derion, God of Bounty',
    SketchGrowBounty,
    'ObtainCard',
    'Derion',
  ),
  tribute(
    'Grow Conquest',
    'Tyros, God of War',
    SketchGrowConquest,
    'ObtainCard',
    'Tyros',
  ),
  tribute(
    'Grow Faith',
    'Zeona, God of Order',
    SketchGrowFaith,
    'ObtainCard',
    'Zeona',
  ),
  tribute('Seek Wonder', 'The Temple', SketchSeekWonder, 'ObtainMostValuable'),
  tribute('Overpower', 'The Hammer', SketchOverpower, 'DefeatOpponent'),
  tribute(
    'Bring Peace',
    'The Dove',
    SketchBringPeace,
    'GainCardWithoutMilitary',
  ),
  tribute('Impulsive Choice', 'The Hare', SketchImpulsiveChoice, 'ObtainFirst'),
  tribute('Patient Choice', 'The Tortoise', SketchPatientChoice, 'ObtainLast'),
  tribute(
    'Grow Polis',
    'The Fountain',
    SketchGrowPolis,
    'ObtainCard',
    'Building',
  ),
  tribute(
    'Grow Community',
    'The Mother',
    SketchGrowCommunity,
    'ObtainCard',
    'Unit',
  ),
  tribute('Grow Legend', 'The Hero', SketchGrowLegend, 'ObtainCard', 'Event'),
  tribute('Show Might', 'The Chariot', SketchShowMight, 'BidMost'),
  tribute('All-In', 'The Flame', SketchAllIn, 'BidAllMilitary'),
  tribute(
    'Seek Modesty',
    'The Mule',
    SketchSeekModesty,
    'ObtainLeastExpensive',
  ),
  tribute(
    'Show Piety',
    'The Dancers',
    SketchShowPiety,
    'CompleteOtherTribute',
    'favor',
  ),
  tribute('Persevere', 'The Dog', SketchPersevere, 'ObtainCard', 'Basic'),
  tribute(
    'Punish Weakness',
    'The Snake',
    SketchPunishWeakness,
    'ClashWithOpponentWithLowestBid',
  ),
  tribute(
    'Seek Humility',
    'The Monk',
    SketchSeekHumility,
    'ObtainLeastValuable',
  ),
];
